export default "__VITE_ASSET__B$5fP7jz__"